export default {
	setBrands: 'SET_BRANDS',
	setBrand: 'SET_BRAND',
	removeBrand: 'REMOVE_BRAND',
	addDefaultImage: 'ADD_BRAND_DEFAULT_IMAGE',
	error: 'ERROR_BRAND',
	loading: 'LOADING_BRAND',
};
